import { render, staticRenderFns } from "./StockAnalysis.vue?vue&type=template&id=4b31ef90&scoped=true&"
import script from "./StockAnalysis.vue?vue&type=script&lang=js&"
export * from "./StockAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./StockAnalysis.vue?vue&type=style&index=0&id=4b31ef90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31ef90",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
